import React, { useEffect, useState, ChangeEvent, useRef } from "react";
import { CheckIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate, useLocation, useParams, Navigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Checkbox } from "@headlessui/react";
import toast from "react-hot-toast";
import { formatDateTime, useData } from "data/data-provider";
import { sanitizeHtml } from "utils/sanitizeHtml";
import { clearRenterSession, setRenterSession } from "utils/renterSession";
import { trackEvent } from "analytics/posthog";
import { getAgreementPdfBase } from "utils/agreement-url";
import { getInvoice } from "api/Invoice/invoice";
import { Booking } from "api/booking/booking";
import { globalJson } from "global/global_json";
import Input from "shared/Input/Input";
import { getBonzahProducts } from "api/bonzah/bonzah";
import { AddCustomer, uploadCustomerFiles } from "api/customer/customer";
import Badge from "shared/Badge/Badge";

import moment from "moment";

import { LocationListingModal } from "models/LocationModal";
import { getLocationData } from "api/locations/locations";
import { getRentalAgreementContent } from "api/rental-agreement/rental-agreement";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import LocationBranchInput from "components/HeroSearchForm/LocationBranchInput";
import DropOffBranchLocationInput from "components/HeroSearchForm/DropOffBranchLocationInput";
import RentalCarDatesRangeInput from "components/HeroSearchForm/(car-search-form)/RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "components/HeroSearchForm/(car-search-form)/RentalCarTimesRangeInput";
import DetailPagetLayout from "containers/ListingDetailPage/Layout";
import NcModal from "shared/NcModal/NcModal";
import useNavigationGuard from "hooks/useNavigationGuard";
import BackRouteButton from "shared/BackRouteButton/BackRouteButton";
import VehicleDescriptionSection from "designs/Common/VehicleDescription/VehicleDescriptionSection";
import BonzahAcknowledgement, {
  BONZAH_POLICY_LINKS,
} from "designs/Common/BonzahAcknowledgement/BonzahAcknowledgement";
import Invoice from "designs/Common/(car-search-form)/invoice";

export default function CarListingCarDetailPage() {
  const navigate = useNavigate();
  const initialBonzahFetched = useRef(false);
  const {
    selectedCar,
    ourVehicles,
    ourVehiclesLoading,
    companyDetails,
    ourLocation: providerLocations,
    user,
    startDate,
    startHours,
    startMinutes,
    startPeriod,
    endDate,
    endHours,
    endMinutes,
    pickupLocation,
    setInvoice,
    selectedExtras,
    setSelectedExtras,
    bonzahProducts,
    setBookingdetails,
    setBonzahProducts,
    setSelectedBonzahProducts,
    selectedBonzahProducts,
    setSelectedBonzahAddOns,
    selectedBonzahAddOns,
    invoice,
    setSameDropoffLocation,
    dropOffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
    sameDropoffLocation,
    dropoffLocationType,
    setDropoffLocationType,
    setDropoffLocation,
    endPeriod,
    firstName,
    setFirstName,
    lastName,
    unavailable,
    setLastName,
    email,
    setEmail,
    phone,
    setPhone,
    setPickupLocation,
    setStartDate,
    setEndDate,
    startTime,
    endTime,
    ourCompany,
    is_hourly_rental,
  } = useData();

  // Funnel step: customer viewed a vehicle listing. Counted as "Viewed
  // vehicle" (scoped by company_id) in the admin monthly-review dashboard.
  useEffect(() => {
    if (selectedCar?.id) {
      trackEvent("vehicle_listing_viewed", {
        vehicle_id: selectedCar?.id,
        vehicle_name: selectedCar?.name,
      });
    }
  }, [selectedCar?.id]);

  let [bonzahProductsLoading, setBonzahProductsLoading] = useState(false);
  const [isDropOffVisible, setIsDropOffVisible] = useState(
    !sameDropoffLocation
  );
  const [selectedBonzahType, setSelectedBonzahType] = useState<any>([]);

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [ourLocation, setOurLocation] = useState<LocationListingModal[]>([]);
  // 1NOW-1421: Bonzah cannot cover elapsed days. When the whole booking is in
  // the past (drop-off date before today) the Bonzah coverages + add-ons are
  // blocked and an error is shown; other (canopy/manual) insurance stays.
  const allDaysInPast = endDate
    ? moment(endDate).isBefore(moment().startOf("day"), "day")
    : false;
  const [isReadMore, setIsReadMore] = useState(true);
  const [selectedBonzah, setSelectedBonzah] = useState();
  const [loadingLater, setLoadingLater] = useState(false);
  const [renterDetailsConfirmed, setRenterDetailsConfirmed] = useState(false);
  const [showImgGallery, setShowImgGallery] = useState(false);
  // In-page image lightbox + grid (ported from template). The legacy
  // DetailPagetLayout gallery (showImgGallery) is kept for compatibility but
  // the header thumbnails now open this lightbox/grid instead.
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isGridOpen, setIsGridOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const pendingNavigationRef = useRef(false);
  // Proof-of-insurance upload (before payment). Files are staged locally and
  // pushed to the customer record via uploadCustomerFiles after the booking
  // is created, gated on the selected product's upload_before_payment flag.
  const [proofOfInsuranceFiles, setProofOfInsuranceFiles] = useState<
    { file: File; url: string }[]
  >([]);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Bonzah acknowledgement modal: gates selecting a Bonzah-issued insurance
  // product behind an eligibility/terms acknowledgement. Holds the product
  // selection that is pending confirmation.
  const [bonzahAckOpen, setBonzahAckOpen] = useState(false);
  const [pendingBonzahSelection, setPendingBonzahSelection] = useState<{
    productType: string;
    value: any;
  } | null>(null);
  // ONENOW-491 / 1NOW-1173: once the renter accepts Bonzah's terms (via the
  // acknowledgement popup) we remember it so the booking-time gate doesn't
  // re-prompt. `pendingBookingMode` records which booking action ("now" →
  // Pay & Book, "later" → Pay Later) was deferred behind the popup so we can
  // replay it after acceptance.
  const [bonzahAcknowledged, setBonzahAcknowledged] = useState(false);
  const [pendingBookingMode, setPendingBookingMode] = useState<
    "now" | "later" | null
  >(null);

  const { isDialogOpen, confirmNavigation, cancelNavigation } =
    useNavigationGuard({
      when: isFormDirty,
      onConfirm: () => {
        pendingNavigationRef.current = true;
        setIsFormDirty(false); // Disable guard before navigation
        // reset form-related state when leaving
        setPickupLocation(null);
        setDropoffLocation(null);
        setStartDate(null);
        setEndDate(null);
        setSameDropoffLocation(true);
        setInvoice([]);
        setDropoffLocationType(true);
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
      },
    });

  useEffect(() => {
    if (!isFormDirty && pendingNavigationRef.current) {
      pendingNavigationRef.current = false;
      window.history.back();
    }
  }, [isFormDirty]);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!firstName?.trim()) {
      newErrors.firstName = "First Name is required";
    }
    if (!lastName?.trim()) {
      newErrors.lastName = "Last Name is required";
    }
    if (!email?.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email.trim())
    ) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!phone?.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (phone.replace(/\D/g, "").length < 10) {
      newErrors.phone = "Please enter a valid phone number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearError = (field: string) => {
    setErrors((prevErrors) => {
      if (!prevErrors[field]) return prevErrors;
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  useEffect(() => {
    // Only clear the location selection on mount when there isn't exactly one
    // active location to auto-select (handled by the filtering effect below).
    const activeLocations = providerLocations.filter(
      (loc) => loc.active !== false
    );
    if (activeLocations.length !== 1) {
      setPickupLocation(null);
      setDropoffLocation(null);
    }
    setStartDate(null);
    setEndDate(null);
    setSameDropoffLocation(true);
    setInvoice([]);
    setDropoffLocationType(true);
  }, []);

  // Active-location filtering: drop any selected pickup/dropoff that is no
  // longer active, and auto-select when exactly one active fleet location is
  // available. Keyed on the fleet-specific `ourLocation` list.
  useEffect(() => {
    const activeLocations = ourLocation.filter((loc) => loc.active !== false);
    if (activeLocations.length === 1) {
      setPickupLocation(activeLocations[0]);
      setDropoffLocation(activeLocations[0]);
      return;
    }
    if (
      pickupLocation &&
      !activeLocations.some((loc) => loc.id === pickupLocation.id)
    ) {
      setPickupLocation(null);
    }
    if (
      dropOffLocation &&
      !activeLocations.some((loc) => loc.id === dropOffLocation.id)
    ) {
      setDropoffLocation(null);
    }
  }, [
    ourLocation,
    pickupLocation,
    dropOffLocation,
    setPickupLocation,
    setDropoffLocation,
  ]);

  useEffect(() => {
    const dirty = Boolean(
      firstName ||
        lastName ||
        email ||
        phone ||
        pickupLocation ||
        dropOffLocation ||
        startDate ||
        endDate
    );
    setIsFormDirty(dirty);
  }, [
    firstName,
    lastName,
    email,
    phone,
    pickupLocation,
    dropOffLocation,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    const activeLocations = providerLocations.filter(
      (loc) => loc.active !== false
    );
    if (activeLocations.length !== 1) {
      setPickupLocation(null);
      setDropoffLocation(null);
    }
    setStartDate(null);
    setEndDate(null);
  }, []);

  const toggleDropOffLocation = () => {
    setIsDropOffVisible((prevState) => !prevState);
  };

  const handleDropOffLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(false);
    setSameDropoffLocation(false);
  };
  const handlePickupLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(true);
    setSameDropoffLocation(true);
    setDropoffLocation(null);
  };

  const isDdropOffdifferent = dropoffLocationType === false;

  const fetchBonzahProducts = async (selectedType?: string) => {
    if (!selectedCar) {
      return;
    }
    setBonzahProductsLoading(true);
    const payload = {
      company_id: globalJson?.prod_company_id,
      selected_type: selectedType,
      fleet: selectedCar?.id,
       pickup_location: pickupLocation?.id,
    };

    const { data } = await getBonzahProducts(payload);

    if (data) {
      setBonzahProducts(data);
      const validAddOns = new Set(
        Array.from(selectedBonzahAddOns).filter((addon: any) =>
          data?.addons?.some((item: any) => item.value[0] === addon)
        )
      );
      setSelectedBonzahAddOns(validAddOns);
      if (data?.insurance_options?.length > 0) {
        if (selectedBonzahType?.length === 0) {
          // 1NOW-1421: never auto-select a Bonzah coverage when the whole
          // booking is in the past — it's blocked.
          const firstOption = data.insurance_options[0];
          const firstIsBlockedBonzah =
            allDaysInPast && firstOption?.insurance_by_bonzah === true;
          if (!firstIsBlockedBonzah) {
            setSelectedBonzahProducts(new Set([firstOption.value]));
            setSelectedBonzahType(firstOption.value);
          }
        }
      }
    }
    setBonzahProductsLoading(false);
  };

  const applyBonzahProductSelection = (productType: string, value: any) => {
    setSelectedBonzahType(value);
    setSelectedBonzahProducts(new Set([value]));
    fetchBonzahProducts(productType);
  };

  const handleBonzahProductSelection = (
    productType: string,
    value: any,
    isBonzahIssued?: boolean
  ) => {
    // Gate selection of a Bonzah-issued product behind the acknowledgement
    // modal. Non-Bonzah products keep the original immediate-selection flow.
    if (isBonzahIssued) {
      setPendingBonzahSelection({ productType, value });
      setBonzahAckOpen(true);
      return;
    }
    applyBonzahProductSelection(productType, value);
  };

  const handleBonzahAckConfirm = () => {
    // Remember acceptance so the booking-time gate (ONENOW-491) doesn't
    // re-prompt for the rest of this session.
    setBonzahAcknowledged(true);
    if (pendingBonzahSelection) {
      applyBonzahProductSelection(
        pendingBonzahSelection.productType,
        pendingBonzahSelection.value
      );
    }
    setBonzahAckOpen(false);
    setPendingBonzahSelection(null);
    // Resume the deferred booking action. We pass `skipBonzahAck=true`
    // so the just-acknowledged state is honoured even though React hasn't
    // committed `bonzahAcknowledged=true` yet by the time this re-invocation
    // reads its closure (ONENOW-491).
    if (pendingBookingMode === "now") {
      setPendingBookingMode(null);
      handleBooking(true);
    } else if (pendingBookingMode === "later") {
      setPendingBookingMode(null);
      handleBookingLater(true);
    }
  };

  const handleBonzahAckClose = () => {
    setBonzahAckOpen(false);
    setPendingBonzahSelection(null);
    // If the renter declines the terms from the booking-time popup, abandon
    // the booking attempt — they shouldn't be auto-submitted without explicit
    // acceptance (ONENOW-491).
    setPendingBookingMode(null);
  };

  useEffect(() => {
    if (!initialBonzahFetched.current) {
      if (!selectedCar) {
        return;
      }
      const fetchInitialBonzah = async () => {
        const { data } = await getBonzahProducts({
          company_id: globalJson?.prod_company_id,
          fleet: selectedCar?.id,
        });

        if (data) {
          setBonzahProducts(data);
          if (data.insurance_options?.length > 0) {
            // 1NOW-1421: never auto-select a Bonzah coverage when the whole
            // booking is in the past — it's blocked.
            const firstOption = data.insurance_options[0];
            const firstIsBlockedBonzah =
              allDaysInPast && firstOption?.insurance_by_bonzah === true;
            if (!firstIsBlockedBonzah) {
              setSelectedBonzahProducts(new Set([firstOption.value]));
              setSelectedBonzahType(firstOption.value);
            }
            fetchBonzahProducts(firstOption.title.toLowerCase());
            setSelectedBonzah(firstOption.title.toLowerCase());
          }
        }
      };
      fetchInitialBonzah();
      initialBonzahFetched.current = true;
    } else {
      if (selectedBonzahType?.length > 0) {
        fetchBonzahProducts(selectedBonzah);
      } else {
        fetchBonzahProducts();
      }
    }
  }, [startDate, endDate, selectedCar, pickupLocation]);

  // 1NOW-1421: if the dates move so the whole booking is in the past, drop any
  // real Bonzah coverage + add-on selection so it can't be submitted (the
  // insurance section shows a blocking error). Canopy/manual options are kept.
  useEffect(() => {
    if (!allDaysInPast) return;
    const selectedProduct = bonzahProducts?.insurance_options?.find(
      (p: any) => JSON.stringify(p.value) === JSON.stringify(selectedBonzahType)
    );
    if (selectedProduct?.insurance_by_bonzah === true) {
      setSelectedBonzahType([]);
      setSelectedBonzahProducts(new Set());
    }
    if (selectedBonzahAddOns && selectedBonzahAddOns.size > 0) {
      setSelectedBonzahAddOns(new Set());
    }
  }, [allDaysInPast, bonzahProducts]);

  const toggleAddonSelection = (addonType: string) => {
    setSelectedBonzahAddOns((prevSelected) => {
      const updatedSet = new Set(prevSelected);
      if (updatedSet.has(addonType)) {
        updatedSet.delete(addonType);
      } else {
        updatedSet.add(addonType);
      }
      return updatedSet;
    });
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      // Don't ship a tentative invoice request before the renter has actually
      // picked dates (ONENOW-493). Also bail if dates are present as Date
      // objects but happen to be `Invalid Date`, so we don't ship an empty
      // `pick_up_time` to a backend that still 500s on it.
      const isValidDate = (d: Date | null | undefined) =>
        !!d && d instanceof Date && !isNaN(d.getTime());
      if (!isValidDate(startDate) || !isValidDate(endDate)) {
        return;
      }
      if (isDdropOffdifferent && dropOffLocation === null) {
        return;
      } else {
        const selectedAddons = Array.from(selectedBonzahAddOns);
        const addonsValues = selectedAddons
          .map((item) => {
            const addon = bonzahProducts.addons.find(
              (addon: any) => addon.value[0] === item
            );
            return addon ? addon.value : [];
          })
          .flat();

        let payload: any = {
          customer: user?.id,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off_address: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
        };

        if (is_hourly_rental) {
          payload = { ...payload, is_hourly_rental: true };
        }

        const data = await getInvoice(payload);
        setInvoice(data);
      }
    };
    fetchInvoice();
  }, [
    selectedExtras,
    selectedBonzahProducts,
    selectedBonzahAddOns,
    pickupLocation,
    startMinutes,
    startPeriod,
    startHours,
    endMinutes,
    endPeriod,
    endHours,
    endMinutes,
    // 1NOW-977: Hours mode writes startTime/endTime directly and the Hours
    // toggle flips is_hourly_rental without touching startDate/endDate.
    // Without these deps the invoice never re-fetches after the flag flips.
    startTime,
    endTime,
    is_hourly_rental,
    endPeriod,
    startDate,
    endDate,
    dropOffLocation,
    sameDropoffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
  ]);

  useEffect(() => {
    setSameDropoffLocation(true);
    setSelectedExtras(new Set());
    setSelectedBonzahProducts(new Set());
    setSelectedBonzahAddOns(new Set());
    clearRenterSession();
  }, []);

  useEffect(() => {
    if (selectedCar) {
      callOurLocationAPI();
    }
  }, [selectedCar]);

  const handleBooking = async (skipBonzahAck = false) => {
    if (!sameDropoffLocation && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null && endDate === null) {
      toast.error("Please enter start and end date");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }
    if (
      companyDetails?.show_renter_confirmation_checkbox &&
      !renterDetailsConfirmed
    ) {
      toast.error("Please confirm that your renter details are correct");
      return;
    }

    if (selectedBonzahProducts.size === 0) {
      toast.error("Please select an insurance option before proceeding.");
      return;
    }

    if (pickupLocation === null) {
      toast.error("Please enter Pick up location");
      return;
    }
    if (sameDropoffLocation === false && dropOffLocation === null) {
      toast.error("Please enter Drop off location");
      return;
    }

    const selectedInsuranceProduct = bonzahProducts?.insurance_options?.find(
      (p: any) => JSON.stringify(p.value) === JSON.stringify(selectedBonzahType)
    );
    const requiresProofOfInsurance =
      selectedInsuranceProduct &&
      selectedInsuranceProduct.upload_before_payment === true;

    // 1NOW-1232: gate on the *requirement*, not on whether files happen to
    // exist. If the selected insurance option requires proof of insurance
    // before payment and the renter hasn't uploaded a document, block the
    // proceed, surface a clear error, and keep them on the page. The backend
    // independently enforces this (source of truth) — this is the UX guard.
    if (requiresProofOfInsurance && proofOfInsuranceFiles.length === 0) {
      toast.error("Please upload proof of insurance before continuing.");
      setLoading(false);
      return;
    }

    // ONENOW-491 compliance gate: if Bonzah is on this booking the renter
    // must have explicitly accepted Bonzah's terms / privacy / eligible
    // vehicle types via the acknowledgement popup before we create the
    // booking. The manual-toggle path gates ack at selection time, but
    // Bonzah can be auto-selected on mount and the renter never goes through
    // that path — so without this check the popup is never shown for the
    // auto-select flow.
    // 1NOW-1173: the gate keys off `insurance_by_bonzah` (NOT canopy), plus
    // any selected Bonzah addon. It does not fire for non-Bonzah products.
    const requiresBonzahAck =
      (selectedInsuranceProduct &&
        selectedInsuranceProduct.insurance_by_bonzah === true) ||
      selectedBonzahAddOns.size > 0;
    if (requiresBonzahAck && !skipBonzahAck && !bonzahAcknowledged) {
      setPendingBookingMode("now");
      setBonzahAckOpen(true);
      return;
    }

    setLoading(true);
    const selectedAddons = Array.from(selectedBonzahAddOns);
    const addonsValues = selectedAddons
      .map((item) => {
        const addon = bonzahProducts.addons.find(
          (addon: any) => addon.value[0] === item
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson?.prod_company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      // AddCustomer already normalizes failures to { error } with renter-safe
      // copy — a blocked identity's refusal (1NOW-10512) surfaces here.
      if (response.error) {
        toast.error(response.error);
        return;
      }

      if (response.data) {
        setRenterSession(response.data);

        const customerId = response.data.id;

        /* The pk goes on the booking, which is a plain FK write. The uuid is

           what names this renter to /api/customers/files/ below — that one

           takes no login, so it no longer answers to a guessable id

           (1NOW-10707). */

        const customerUid = response.data.unique_identifier;

        let payload: any = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
        };

        if (is_hourly_rental) {
          payload = { ...payload, is_hourly_rental: true };
        }

        const bookingResponse = await Booking(payload);
        setBookingdetails(bookingResponse);
        if (bookingResponse.error) {
          toast.error(bookingResponse.error);
          return;
        }

        if (
          requiresProofOfInsurance &&
          proofOfInsuranceFiles.length > 0 &&
          bookingResponse?.id
        ) {
          for (const { file } of proofOfInsuranceFiles) {
            await uploadCustomerFiles(String(customerUid), [file], "insurance");
          }
          setProofOfInsuranceFiles([]);
        }

        navigate("/checkout");
      }
    } catch (err: any) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleBookingLater = async (skipBonzahAck = false) => {
    if (isDdropOffdifferent && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null && endDate === null) {
      toast.error("Please enter start and end date");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }
    if (
      companyDetails?.show_renter_confirmation_checkbox &&
      !renterDetailsConfirmed
    ) {
      toast.error("Please confirm that your renter details are correct");
      return;
    }
    if (selectedBonzahProducts.size === 0) {
      toast.error("Please select an insurance option before proceeding.");
      return;
    }

    const selectedInsuranceProductLater =
      bonzahProducts?.insurance_options?.find(
        (p: any) =>
          JSON.stringify(p.value) === JSON.stringify(selectedBonzahType)
      );
    const requiresProofOfInsuranceLater =
      selectedInsuranceProductLater &&
      selectedInsuranceProductLater.upload_before_payment === true;

    // 1NOW-1232: same proof-of-insurance gate as the Pay path — block the
    // Pay Later proceed identically until a document is uploaded.
    if (requiresProofOfInsuranceLater && proofOfInsuranceFiles.length === 0) {
      toast.error("Please upload proof of insurance before continuing.");
      setLoadingLater(false);
      return;
    }

    // Same compliance gate as handleBooking. See the long comment there for
    // rationale (ONENOW-491 / 1NOW-1173).
    const requiresBonzahAckLater =
      (selectedInsuranceProductLater &&
        selectedInsuranceProductLater.insurance_by_bonzah === true) ||
      selectedBonzahAddOns.size > 0;
    if (requiresBonzahAckLater && !skipBonzahAck && !bonzahAcknowledged) {
      setPendingBookingMode("later");
      setBonzahAckOpen(true);
      return;
    }

    setLoadingLater(true);

    const selectedAddons = Array.from(selectedBonzahProducts)?.filter((item) =>
      bonzahProducts?.addons.some((addon: any) => addon.value[0] === item)
    );

    const addonsValues: string[] = selectedAddons
      .map((item) => {
        const addon = bonzahProducts?.addons?.find(
          (addon: any) => addon.value[0] === item
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.prod_company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      if (response.error) {
        toast.error(response.error);
        return;
      }
      if (!startDate || !endDate) {
        toast.error("No start date or end date");
        return;
      }

      if (response.data) {
        setRenterSession(response.data);

        const customerId = response.data.id;

        /* The pk goes on the booking, which is a plain FK write. The uuid is

           what names this renter to /api/customers/files/ below — that one

           takes no login, so it no longer answers to a guessable id

           (1NOW-10707). */

        const customerUid = response.data.unique_identifier;

        let payload: any = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),

          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
          pay_later: true,
        };

        if (is_hourly_rental) {
          payload = { ...payload, is_hourly_rental: true };
        }

        const bookingdetail = await Booking(payload);
        if (bookingdetail.error) {
          toast.error(bookingdetail.error);
          setLoadingLater(false);
          return;
        }
        if (
          requiresProofOfInsuranceLater &&
          proofOfInsuranceFiles.length > 0 &&
          bookingdetail?.id
        ) {
          for (const { file } of proofOfInsuranceFiles) {
            await uploadCustomerFiles(String(customerUid), [file], "insurance");
          }
          setProofOfInsuranceFiles([]);
        }
        setBookingdetails(bookingdetail);
        // Fetch the rental agreement (with privacy + cancellation content)
        // then route to the pay-later policies page, passing the content in
        // router state so it renders without a second round-trip. company_id
        // stays static (this site's convention) — see openRentalAgreement on the
        // booking-details page.
        /* The agreement key is the booking's uuid. The old
           `{pk}b6cr4{companyId}b6cr4{base64(email)}` salt read like a secret
           but was not — the backend only ever looked at the first segment, so
           a guessed integer opened any operator's agreement (1NOW-10707). */
        const path = bookingdetail?.unique_identifier;
        const pdfBase = getAgreementPdfBase();
        const pdfUrl = `${pdfBase}${path}`;
        let agreementContent: any = null;
        let privacyPolicyContent: any = [];
        let cancellationPolicyContent: any = [];
        try {
          const agResponse = await getRentalAgreementContent(path);
          if (agResponse?.data) {
            agreementContent = agResponse.data;
            privacyPolicyContent = agResponse.data.content?.privacy_policy;
            cancellationPolicyContent =
              agResponse.data.content?.cancellation_policy;
          }
        } catch (e) {
          console.error("Error fetching rental agreement:", e);
        }
        setProofOfInsuranceFiles([]);
        navigate("/pay-later-policies", {
          state: {
            bookingIdentifier: bookingdetail?.unique_identifier,
            pdfUrl,
            agreementContent,
            privacyPolicyContent,
            cancellationPolicyContent,
          },
        });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to complete booking");
      setLoadingLater(false);
    } finally {
      setLoadingLater(false);
    }
  };

  const callOurLocationAPI = async () => {
    if (selectedCar) {
      try {
        const data = await getLocationData(selectedCar?.id);
        if (Array.isArray(data)) {
          setOurLocation(data as LocationListingModal[]);
        } else {
          throw new Error("Unable to fetch location data");
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch locations");
        console.error("Location API error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const closeGridModal = () => setIsGridOpen(false);

  const handleOpenModalImageGallery = (index: number) => {
    if (selectedCar?.fleet_photos?.length === 0) {
      toast("No Images available for this fleet", {
        style: {
          background: "#fff3cd",
          color: "#856404",
        },
      });
    } else {
      setCurrentIndex(index);
      setIsOpenModal(true);
    }
  };

  const vehicleDescriptionSection = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Vehicle Description</h2>
        {selectedCar?.description && (
          <div className="break-words overflow-hidden">
            <p className="whitespace-pre-line break-words">
              {isReadMore
                ? selectedCar?.description?.slice(0, 230)
                : selectedCar?.description}
              {(selectedCar?.description?.length ?? 0) > 230 && (
                <span
                  className="text-primary-100 cursor-pointer"
                  onClick={toggleReadMore}
                >
                  {isReadMore ? " ...read more" : " ...show less"}
                </span>
              )}
            </p>
          </div>
        )}
        {selectedCar?.features && selectedCar.features.length > 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-6 gap-x-10 text-sm">
            {selectedCar?.features?.map((item, index) => (
              <div key={index} className="flex items-center space-x-4 ">
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderUserSection = () => {
    return (
      <div className="border-[#E5E7EB] flex flex-col sm:rounded-2xl border-b sm:border-t sm:border-l sm:border-r sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        {" "}
        <h2 className="text-xl text-[#111827] font-bold">Trip Details</h2>
        <form className="flex flex-col border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <div className={`${isDdropOffdifferent ? " " : "w-full my-2"}`}>
            <LocationBranchInput
              ourLocation={ourLocation}
              placeHolder="Pick Up Location"
              className="w-full bg-white rounded-xl border text-black placeholder:text-black"
              sameDropOffLocation={dropoffLocationType === false}
              searchBar={false}
            />
          </div>
          {isDropOffVisible && (
            <div className="my-2">
              <DropOffBranchLocationInput
                ourLocation={ourLocation}
                placeHolder="Dropoff Location"
                className="w-full bg-white rounded-xl border"
                divHideVerticalLineClass="-inset-x-0.5"
                searchBar={false}
              />

              <p
                className="text-xs text-primary-200 cursor-pointer mt-2 font-semibold"
                onClick={handlePickupLocationClick}
              >
                - Same Dropoff Location
              </p>
            </div>
          )}

          {/* If drop-off location is not visible, show the toggle text */}
          {!isDropOffVisible && (
            <p
              className="text-xs text-primary-200 cursor-pointer mb-2 font-semibold"
              onClick={handleDropOffLocationClick}
            >
              + Different Dropoff Location
            </p>
          )}

          {pickupLocation && (
            <RentalCarDatesRangeInput
              isMiddle={true}
            className="w-full bg-white rounded-xl my-2 border"
              selectedCar={selectedCar}
              searchBar={false}
              minDays={selectedCar?.min_trip_duration}
              maxDays={selectedCar?.max_trip_duration}
            />
          )}

          {startDate && endDate && (
            <RentalCarTimesRangeInput
              dropOffLocationType={dropoffLocationType}
                  className="w-full bg-white rounded-xl border my-2"
              searchBar={false}
            />
          )}
        </form>
        <h2 className="text-xl text-[#111827] font-bold">Renter Details</h2>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border p-2 rounded-xl">
              <span className="my-2 text-sm">First Name</span>
              <Input
                placeholder=""
                value={firstName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setFirstName(e.target.value);
                  setRenterDetailsConfirmed(false);
                  if (e.target.value) clearError("firstName"); // Clear error if input is valid
                }}
              />
            </div>
            {errors.firstName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.firstName}
              </span>
            )}
          </div>
          <div>
            <div className="border p-2 rounded-xl">
              <span className="my-2 text-sm">Last Name</span>
              <Input
                placeholder=""
                value={lastName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setLastName(e.target.value);
                  setRenterDetailsConfirmed(false);
                  if (e.target.value) clearError("lastName");
                }}
              />
            </div>
            {errors.lastName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.lastName}
              </span>
            )}
          </div>
          <div>
            <div className="border p-2 rounded-xl">
              <span className="my-2 text-sm">Email</span>
              <Input
                placeholder=""
                type="email"
                className="border-none !p-0 focus:outline-none focus:ring-0"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setEmail(e.target.value);
                  if (
                    /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                      e.target.value
                    )
                  ) {
                    clearError("email");
                  }
                }}
              />
            </div>
            {errors.email && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.email}
              </span>
            )}
          </div>
          <div>
            <div className="border p-2 rounded-xl">
              <span className="my-2 text-sm">Phone</span>
              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(phone) => {
                  setPhone(phone);
                  setRenterDetailsConfirmed(false);
                  if (phone.length >= 10) clearError("phone");
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: false,
                }}
                inputStyle={{
                  border: "none",
                  width: "100%",
                  minHeight: "44px",
                  boxShadow: "none",
                }}
                buttonStyle={{
                  background: "transparent",
                  border: "none",
                }}
              />
            </div>
            {errors.phone && (
              <span className="text-red-500 text-xs font-semibold ">
                {errors.phone}
              </span>
            )}
          </div>
        </div>
        {companyDetails?.show_renter_confirmation_checkbox && (
          <div className="flex gap-2 mt-4  items-center">
            <Checkbox
              checked={renterDetailsConfirmed}
              onChange={(checked) => {
                if (!validateForm()) {
                  toast.error(
                    "Please fill in your renter details above before confirming"
                  );
                  return;
                }
                setRenterDetailsConfirmed(checked);
              }}
              className={`group size-7 rounded-md p-1 ring-1 ring-primary-200 data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20 ring-inset mr-4 flex-shrink-0 ${
                !firstName || !lastName || !email || phone.length < 10
                  ? "opacity-60"
                  : ""
              }`}
            >
              <CheckIcon
                className={`size-5 stroke-primary-200 ${
                  renterDetailsConfirmed ? "visible" : "invisible"
                }`}
              />
            </Checkbox>
            {companyDetails?.renter_confirmation_checkbox_text ? (
              <span
                className="text-text-color text-sm policy-checkbox-copy"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(
                    companyDetails.renter_confirmation_checkbox_text.replace(
                      /\{\{\s*company\s*name\s*\}\}/gi,
                      companyDetails?.company_name ?? ""
                    )
                  ),
                }}
              />
            ) : (
              <span className="text-text-color text-sm">
                I confirm that my renter details are correct and I agree to
                receive communication from {companyDetails?.company_name} about
                my rental booking, service updates, and related offers.
              </span>
            )}
          </div>
        )}
      </div>
    );
  };

  const handleExtraChange = (extraId: any, checked: any) => {
    setSelectedExtras((prevSelectedExtras) => {
      const updatedExtras = new Set(prevSelectedExtras);
      if (checked) {
        updatedExtras.add(extraId);
      } else {
        updatedExtras.delete(extraId);
      }
      return updatedExtras;
    });
  };

  const renderSidebar = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        <div className="w-full max-w-lg  mx-auto bg-white dark:bg-gray-800">
          <h2 className="text-xl font-medium text-gray-900 dark:text-gray-100">
            Rental Bill
          </h2>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Prices may change depending on the length of the rental and the
            price of your rental car.
          </p>

          {pickupLocation !== null && invoice?.car_total !== undefined && (
            <Invoice invoice={invoice} carName={selectedCar?.name} />
          )}
        </div>

        <ButtonPrimary
          className="block rounded-lg"
          disabled={unavailable || loading}
          onClick={() => {
            handleBooking();
          }}
        >
          {loading ? (
            <div className="flex justify-center items-center col-span-full">
              <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
            </div>
          ) : (
            " Pay & Book"
          )}
        </ButtonPrimary>
        {selectedCar?.pay_later && (
          <ButtonPrimary
            className="block rounded-lg mt-4"
            disabled={loadingLater}
            onClick={() => {
              handleBookingLater();
            }}
          >
            {loadingLater ? (
              <div className="flex justify-center items-center col-span-full">
                <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
              </div>
            ) : (
              "Pay Later"
            )}
          </ButtonPrimary>
        )}
      </div>
    );
  };

  const renderDescriptionWithLink = (description: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = description.split(urlRegex);

    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  useEffect(() => {
    if (selectedCar?.extras) {
      const requiredExtras = selectedCar.extras
        .filter((extra: any) => extra.is_required)
        .map((extra: any) => extra.id);
      setSelectedExtras((prev) => {
        const updated = new Set(prev);
        requiredExtras.forEach((id) => updated.add(id));
        return updated;
      });
    }
  }, [selectedCar]);

  const renderExtrasSection = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-bold text-[#111827]">Extras</h2>
        {!bonzahProductsLoading &&
          !is_hourly_rental &&
          !allDaysInPast &&
          bonzahProducts?.addons?.map((addon: any) => (
            <div
              key={addon.title}
              className="flex flex-col justify-between items-start border rounded-lg p-4 bg-white dark:bg-gray-800 max-w-full"
            >
              <div className="flex items-start">
                <Checkbox
                  checked={selectedBonzahAddOns.has(addon.value[0])}
                  onChange={() => toggleAddonSelection(addon.value[0])}
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20 ring-inset  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${
                      selectedBonzahAddOns.has(addon.value[0])
                        ? "visible"
                        : "invisible"
                    }`}
                  />
                </Checkbox>

                <div>
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white">
                      {addon.title}
                    </h2>
                    {addon?.pdf && (
                      <button
                        className="ml-3 inline-flex items-center gap-1 rounded-md border border-neutral-300 px-2.5 py-1 text-xs font-medium text-text-color hover:bg-neutral-100"
                        onClick={() => window.open(addon.pdf, "_blank")}
                        type="button"
                        tabIndex={-1}
                      >
                        View Coverage
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {addon?.options &&
                    Object.entries(addon.options).map(([key, values]) => (
                      <div key={key} className="mt-2">
                        <ul className="list-disc pl-5 text-sm text-text-color space-y-1">
                          {(Array.isArray(values) ? values : [values]).map(
                            (detail: any, idx: number) => (
                              <li key={idx} style={{ wordBreak: "break-word" }}>
                                {detail}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    ))}

                  <p className="mt-2 text-xs text-neutral-500">
                    Please review Bonzah&apos;s{" "}
                    {BONZAH_POLICY_LINKS.map((link, idx) => (
                      <React.Fragment key={link.href}>
                        {idx > 0 &&
                          (idx === BONZAH_POLICY_LINKS.length - 1
                            ? ", and "
                            : ", ")}
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary-200 underline hover:no-underline"
                        >
                          {link.short.toLowerCase()}
                        </a>
                      </React.Fragment>
                    ))}{" "}
                    before selecting.
                  </p>
                </div>
              </div>
              <div className="mt-4 md:mt-0 w-full">
                <p className="lg:text-2xl text-lg font-bold text-gray-900 dark:text-gray-100 flex justify-end items-center">
                  ${addon?.price?.toFixed(2)}
                  <span className="text-gray-400 lg:text-lg">/day</span>
                </p>
              </div>
            </div>
          ))}
        {selectedCar?.extras.map((extra) => (
          <div
            key={extra.id}
            className="w-full rounded-md border  border-gray-200 flex flex-wrap justify-between items-center p-5"
          >
            <div className="flex justify-start flex-1 min-w-0">
              <Checkbox
                checked={selectedExtras?.has(extra.id)}
                onChange={(checked) => {
                  if (!extra.is_required) {
                    handleExtraChange(extra.id, checked);
                  }
                }}
                className="group size-7 rounded-md  p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                disabled={extra.is_required}
              >
                <CheckIcon
                  className={`size-5 stroke-primary-200 ${
                    selectedExtras.has(extra.id) ? "visible" : "invisible"
                  }`}
                />
              </Checkbox>
              <div className="min-w-0">
                <div className="text-gray-900 dark:text-gray-200 lg:text-lg sm:text-l font-bold flex space-x-2 flex-wrap break-words">
                  <span className="truncate block max-w-xs">{extra.name}</span>
                </div>
                <div className="text-gray-400 dark:text-neutral-400 lg:text-lg sm:text-md font-medium ">
                  {renderDescriptionWithLink(extra.description)}
                </div>
              </div>
            </div>

            <div className="mt-4 md:mt-0 flex-shrink-0 flex flex-col items-end">
              <div className="mb-2 flex space-x-2">
                {extra.is_required && <Badge color="blue" name="Required" />}
                {extra.is_recommended === true && (
                  <Badge color="blue" name="Recommended" />
                )}
              </div>
              <p className="lg:text-2xl text-lg font-bold text-gray-900 dark:text-gray-100 flex justify-end items-center whitespace-nowrap">
                ${extra?.amount}
                <span className="text-gray-400 lg:text-lg">
                  {" "}
                  /{extra?.nature === "per_day" ? "day" : "trip"}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderBonzahSection = () => {
    // Hide Bonzah / TeqMobility insurance UI for hourly bookings (1NOW-977)
    if (is_hourly_rental) return null;
    // Hide the section only when there is nothing to offer. The old guard
    // counted non-Bonzah options only, so a Bonzah-only catalog hid the whole
    // section while the first option was still auto-selected. Template gates
    // on the full list the same way (its check sits at the call site).
    if (!bonzahProducts?.insurance_options?.length) return null;
    return (
      <div className="listingSection__wrap rounded-md">
        <h2 className="text-2xl text-[#111827] font-bold">Trip Insurance</h2>
        {allDaysInPast && (
          <div className="border border-red-200 bg-red-50 rounded-md p-4 text-sm text-red-700">
            Bonzah cannot be added because all booking days are in the past.
          </div>
        )}
        {bonzahProducts?.insurance_options
          // 1NOW-1599: Bonzah is offered regardless of trip length — >30-day
          // coverage is purchased as multiple ≤30-day split policies on the
          // backend, matching the FMS create flow.
          // 1NOW-1421: block Bonzah coverages when the whole booking is past.
          ?.filter(
            (product: any) =>
              !(allDaysInPast && product.insurance_by_bonzah === true)
          )
          .map((product: any, index: any) => (
            <div
              key={product.title}
              className="flex flex-col justify-between items-start border rounded-lg p-4 bg-white dark:bg-gray-800 max-w-full overflow-hidden"
              style={{ wordBreak: "break-word" }}
            >
              <div className="flex items-start w-full">
                <Checkbox
                  checked={
                    JSON.stringify(selectedBonzahType) ===
                    JSON.stringify(product?.value)
                  }
                  onChange={() =>
                    handleBonzahProductSelection(
                      product.title.toLowerCase(),
                      product?.value,
                      product?.insurance_by_bonzah === true
                    )
                  }
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${
                      JSON.stringify(selectedBonzahType) ===
                      JSON.stringify(product?.value)
                        ? "visible"
                        : "invisible"
                    }`}
                  />
                </Checkbox>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-gray-900 dark:text-gray-100 truncate">
                      {product.title}
                    </h2>
                    {product?.pdf !== "" && (
                      <button
                        className="ml-3 inline-flex items-center gap-1 rounded-md border border-neutral-300 px-2.5 py-1 text-xs font-medium text-text-color hover:bg-neutral-100"
                        onClick={() => window.open(product.pdf, "_blank")}
                        type="button"
                        tabIndex={-1}
                      >
                        View Coverage
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {product?.options &&
                    Object.entries(product.options).map(([key, values]) => (
                      <div key={key} className="mt-2">
                        {!product.canopy && product.insurance_by_bonzah && (
                          <h3 className="font-semibold text-gray-700 dark:text-gray-300 uppercase truncate">
                            {key}
                          </h3>
                        )}

                        <p className="text-sm text-gray-600 dark:text-gray-400 break-words">
                          {(Array.isArray(values) ? values : [values]).map(
                            (detail, index) => {
                              // If detail is HTML from Quill editor, render as HTML but make links clickable
                              if (
                                typeof detail === "string" &&
                                detail.trim().startsWith("<")
                              ) {
                                // Replace URLs in HTML with anchor tags if not already wrapped
                                const urlRegex = /(https?:\/\/[^\s<>"']+)/g;
                                let html = detail.replace(urlRegex, (url) => {
                                  // If already inside an anchor tag, skip
                                  if (detail.includes(`<a href="${url}`))
                                    return url;
                                  return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${url}</a>`;
                                });
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                    dangerouslySetInnerHTML={{
                                      __html: sanitizeHtml(html),
                                    }}
                                  />
                                );
                              }
                              // If detail contains a URL, make it clickable
                              const urlRegex = /(https?:\/\/[^\s]+)/g;
                              if (
                                typeof detail === "string" &&
                                urlRegex.test(detail)
                              ) {
                                const parts = detail.split(urlRegex);
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {parts.map((part, i) =>
                                      urlRegex.test(part) ? (
                                        <a
                                          key={i}
                                          href={part}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-blue-500 hover:underline"
                                          style={{ wordBreak: "break-word" }}
                                        >
                                          {part}
                                        </a>
                                      ) : (
                                        <React.Fragment key={i}>
                                          {part}
                                        </React.Fragment>
                                      )
                                    )}
                                    <br />
                                  </span>
                                );
                              }
                              // Otherwise, render as plain text
                              return (
                                <span
                                  key={index}
                                  className={
                                    product.canopy
                                      ? "text-red-500 font-semibold"
                                      : ""
                                  }
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {detail}
                                  <br />
                                </span>
                              );
                            }
                          )}
                        </p>
                      </div>
                    ))}
                </div>
              </div>

              <div className="mt-4 md:mt-0 w-full flex justify-end items-center">
                <p className="text-2xl font-bold text-gray-900 dark:text-gray-100 truncate">
                  ${product.price.toFixed(2)}
                  <span className="text-gray-400 lg:text-lg">
                    /
                    {product.nature === "per_trip"
                      ? "trip"
                      : product.nature === "per_day"
                      ? "day"
                      : "24 hours"}
                  </span>
                </p>
              </div>
              {product.upload_before_payment === true &&
                JSON.stringify(selectedBonzahType) ===
                  JSON.stringify(product?.value) && (
                  <div className="mt-4 w-full">
                    {proofOfInsuranceFiles.length > 0 && (
                      <div className="mb-3 flex flex-col gap-2">
                        {proofOfInsuranceFiles.map(({ file, url }, index) => (
                          <div
                            key={index}
                            className="w-full border border-neutral-200 rounded-md p-4 flex items-center gap-4"
                          >
                            {file.type.startsWith("image/") ? (
                              <img
                                src={url}
                                alt="Proof of Insurance preview"
                                className="h-24 w-40 object-cover rounded-md flex-shrink-0"
                              />
                            ) : file.type.startsWith("video/") ? (
                              <video
                                src={url}
                                className="h-24 w-40 object-cover rounded-md flex-shrink-0 bg-black"
                                controls
                                preload="metadata"
                                playsInline
                              />
                            ) : (
                              <div className="h-24 w-40 flex items-center justify-center bg-gray-100 rounded-md flex-shrink-0">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="32"
                                  height="32"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="#9AA3AD"
                                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z"
                                  />
                                </svg>
                              </div>
                            )}
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-text-color truncate">
                                {file.name}
                              </p>
                              <p className="text-xs text-gray-400 mt-1">
                                {file.size >= 1024 * 1024
                                  ? `${(file.size / (1024 * 1024)).toFixed(
                                      2
                                    )} MB`
                                  : `${(file.size / 1024).toFixed(1)} KB`}
                              </p>
                              <div className="flex gap-3 mt-2">
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-xs text-primary-200 font-semibold hover:underline"
                                >
                                  {file.type.startsWith("image/")
                                    ? "Preview"
                                    : file.type.startsWith("video/")
                                    ? "Play"
                                    : "Open"}
                                </a>
                                <button
                                  type="button"
                                  onClick={() => {
                                    URL.revokeObjectURL(url);
                                    setProofOfInsuranceFiles((prev) =>
                                      prev.filter((_, i) => i !== index)
                                    );
                                    if (fileInputRef.current)
                                      fileInputRef.current.value = "";
                                  }}
                                  className="text-xs text-red-500 font-semibold hover:underline"
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: "none" }}
                      accept="image/*,application/pdf"
                      multiple
                      onChange={(e) => {
                        const files = e.target.files
                          ? Array.from(e.target.files)
                          : [];
                        // Proof of insurance is a document — reject video (and
                        // any other unsupported type) and tell the renter why
                        // (1NOW-1232).
                        const allowed = files.filter(
                          (f) =>
                            f.type.startsWith("image/") ||
                            f.type === "application/pdf"
                        );
                        if (allowed.length < files.length) {
                          toast.error(
                            "Videos aren't supported. Please upload an image or PDF."
                          );
                        }
                        if (allowed.length > 0) {
                          setProofOfInsuranceFiles((prev) => [
                            ...prev,
                            ...allowed.map((f) => ({
                              file: f,
                              url: URL.createObjectURL(f),
                            })),
                          ]);
                        }
                        e.target.value = "";
                      }}
                    />
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => fileInputRef.current?.click()}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ")
                          fileInputRef.current?.click();
                      }}
                      className="flex flex-col items-center justify-center w-full border-2 border-dashed border-neutral-200 rounded-md p-6 cursor-pointer hover:border-primary-200 transition-colors"
                    >
                      <svg
                        width="44"
                        height="44"
                        viewBox="0 0 44 44"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="2"
                          y="2"
                          width="40"
                          height="40"
                          rx="8"
                          stroke="#9AA3AD"
                          strokeWidth="2"
                        />
                        <path
                          d="M22 30V14M22 14L16 20M22 14L28 20"
                          stroke="#9AA3AD"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="mt-2 text-sm text-text-color">
                        Proof Of Insurance
                      </span>
                    </div>
                  </div>
                )}
            </div>
          ))}
      </div>
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const carIdParam = searchParams.get("selectedCarId");

    if (!carIdParam) {
      navigate("/");
    }
  }, []);

  // 404 deep-link guard: while the car for `selectedCarId` hasn't resolved,
  // show a spinner if the fleet list is still loading or the car genuinely
  // exists in it. If the list has loaded and the id isn't present, the deep
  // link is bad — route to the 404 page (catch-all route renders Page404).
  const carIdParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("selectedCarId")
      : null;

  if (carIdParam && !selectedCar) {
    const stillLoading = ourVehiclesLoading || ourVehicles.length === 0;
    const carExists = ourVehicles.some((v) => String(v.id) === carIdParam);

    if (stillLoading || carExists) {
      return (
        <DetailPagetLayout
          showImgGallery={showImgGallery}
          setShowImgGallery={setShowImgGallery}
        >
          <div className="flex justify-between items-center my-4">
            <BackRouteButton className="mt-4" />
          </div>
          <div className="flex flex-col justify-center items-center min-h-[50vh] gap-4">
            <div className="w-10 h-10 rounded-full border-4 border-neutral-200 border-t-primary-6000 animate-spin" />
          </div>
        </DetailPagetLayout>
      );
    }

    return <Navigate to="/404" replace />;
  }

  return (
    <DetailPagetLayout
      showImgGallery={showImgGallery}
      setShowImgGallery={setShowImgGallery}
    >
      <>
        <BackRouteButton className="mt-4" />
        <BonzahAcknowledgement
          isOpen={bonzahAckOpen}
          onClose={handleBonzahAckClose}
          onConfirm={handleBonzahAckConfirm}
        />
        <div className={` nc-ListingCarDetailPage mt-4`}>
          <header className="rounded-md sm:rounded-md">
            <div className="relative grid grid-cols-1 md:grid-cols-4  gap-1 sm:gap-2 min-h-96 ">
              <div
                className="col-span-2 row-span-2 relative rounded-md sm:rounded-md overflow-hidden cursor-pointer"
                onClick={() => {
                  handleOpenModalImageGallery(0);
                  setCurrentIndex(0);
                }}
              >
                <img
                  src={
                    (selectedCar?.fleet_photos?.length ?? 0) > 0
                      ? selectedCar?.fleet_photos[0].photo_url?.includes("http")
                        ? selectedCar?.fleet_photos[0].photo_url
                        : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[0].photo_url}`
                      : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                  }
                  alt="0"
                  className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
              </div>

              {/*  */}
              <div
                className="col-span-1 row-span-2 relative rounded-md sm:rounded-md overflow-hidden cursor-pointer"
                onClick={() => {
                  handleOpenModalImageGallery(1);
                  setCurrentIndex(1);
                }}
              >
                <img
                  className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                  src={
                    (selectedCar?.fleet_photos?.length ?? 0) > 1
                      ? selectedCar?.fleet_photos[1].photo_url?.includes("http")
                        ? selectedCar?.fleet_photos[1].photo_url
                        : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[1].photo_url}`
                      : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                  }
                  alt="1"
                  sizes="400px"
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
              </div>

              {/*  */}
              {selectedCar?.fleet_photos
                .filter((_, i) => i >= 2 && i < 4)
                .map((item, index) => (
                  <div
                    key={index}
                    className={`relative rounded-md sm:rounded-md overflow-hidden ${
                      index >= 2 ? "block" : ""
                    }`}
                  >
                    <div className="aspect-w-4 aspect-h-3">
                      <img
                        className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-md "
                        src={
                          item.photo_url?.includes("http")
                            ? item.photo_url
                            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                        }
                        alt="photos"
                        sizes="400px"
                      />
                    </div>
                    <div
                      className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                      onClick={() => {
                        handleOpenModalImageGallery(index + 2);
                        setCurrentIndex(index + 2);
                      }}
                    />
                  </div>
                ))}

              {(selectedCar?.fleet_photos?.length ?? 0) > 1 && (
                <div
                  className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
                  onClick={() => setIsGridOpen(true)}
                >
                  <Squares2X2Icon className="h-5 w-5" />
                  <span className="ml-2 text-neutral-800 text-sm font-medium">
                    Show all photos
                  </span>
                </div>
              )}
            </div>
          </header>

          {isGridOpen && (
            <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4">
              <div className="relative w-full max-w-5xl bg-white rounded-lg overflow-auto p-4">
                <button
                  className="absolute top-1 right-3 text-lg text-text-color bg-white rounded-full w-10 h-10 flex items-center justify-center z-10"
                  onClick={closeGridModal}
                  aria-label="Close gallery"
                  type="button"
                >
                  ✖
                </button>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 pt-8">
                  {(selectedCar?.fleet_photos ?? []).map(
                    (item: any, idx: number) => (
                      <button
                        key={idx}
                        onClick={() => {
                          setCurrentIndex(idx);
                          setIsOpenModal(true);
                          setIsGridOpen(false);
                        }}
                        className="w-full h-32 sm:h-40 md:h-48 overflow-hidden rounded-md focus:outline-none focus:ring-2 focus:ring-primary-100 transition-transform hover:scale-105"
                        type="button"
                      >
                        <img
                          src={
                            item.photo_url?.includes("http")
                              ? item.photo_url
                              : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                          }
                          alt={`photo-${idx}`}
                          className="w-full h-full object-cover"
                        />
                      </button>
                    )
                  )}
                  {(selectedCar?.fleet_photos?.length ?? 0) === 0 && (
                    <div className="col-span-full text-center p-8 text-text-color">
                      No images available
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {isOpenModal && (
            <div className="fixed h-full top-0 left-0 w-full bg-bg-color  flex items-center justify-center z-50">
              <button
                className="absolute top-5 right-5 text-text-color text-xl"
                onClick={closeModal}
              >
                ✖
              </button>

              <div className="w-4/5 ">
                <Slide
                  defaultIndex={currentIndex}
                  indicators={(selectedCar?.fleet_photos?.length ?? 0) > 1}
                  arrows={(selectedCar?.fleet_photos?.length ?? 0) > 1}
                  autoplay={false}
                  duration={2000}
                  transitionDuration={300}
                  onChange={(current, next) => {
                    setCurrentIndex(next);
                  }}
                  prevArrow={
                    <button
                      className={`absolute left-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${
                        (selectedCar?.fleet_photos?.length ?? 0) <= 1 ||
                        currentIndex === 0
                          ? "invisible"
                          : ""
                      }`}
                      type="button"
                      aria-label="Previous"
                    >
                      <span className="default-nav !text-text-color">❮</span>
                    </button>
                  }
                  nextArrow={
                    <button
                      className={`absolute right-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${
                        (selectedCar?.fleet_photos?.length ?? 0) <= 1 ||
                        currentIndex ===
                          (selectedCar?.fleet_photos?.length ?? 0) - 1
                          ? "invisible"
                          : ""
                      }`}
                      type="button"
                      aria-label="Next"
                    >
                      <span className="default-nav !text-text-color">❯</span>
                    </button>
                  }
                >
                  {((selectedCar?.fleet_photos?.length ?? 0) || 0) > 0 ? (
                    selectedCar?.fleet_photos?.map(
                      (item: any, index: number) => (
                        <div
                          className="flex justify-center items-center h-full"
                          key={index}
                        >
                          <img
                            className="w-full max-h-full object-contain rounded-lg"
                            src={
                              item.photo_url?.includes("http")
                                ? item.photo_url
                                : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                            }
                            alt={`Slide ${index}`}
                          />
                        </div>
                      )
                    )
                  ) : (
                    <div className="flex justify-center items-center h-full">
                      <img
                        className="w-full max-h-full object-contain rounded-lg"
                        src="https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                        alt="No images available"
                      />
                    </div>
                  )}
                </Slide>
              </div>
            </div>
          )}
          <NcModal
            isOpenProp={isDialogOpen}
            onCloseModal={cancelNavigation}
            modalTitle={"Leave this page?"}
            contentExtraClass="max-w-md"
            renderContent={() => (
              <div>
                <p className="text-sm text-neutral-600 dark:text-neutral-300">
                  Your entered information will be lost. Are you sure you want
                  to go back?
                </p>
                <div className="mt-6 flex justify-end space-x-3">
                  <button
                    type="button"
                    className="px-4 py-2 rounded-md border border-neutral-300 dark:border-neutral-700"
                    onClick={cancelNavigation}
                  >
                    Stay
                  </button>
                  <button
                    type="button"
                    className="px-4 py-2 rounded-md bg-red-600 text-white"
                    onClick={confirmNavigation}
                  >
                    Leave
                  </button>
                </div>
              </div>
            )}
          />
          <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
            <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:pr-10 lg:space-y-10">
              {/* {vehicleFeaturesSection()} */}
              {/* New design-system vehicle description; degrades gracefully on
                  fields the car model doesn't expose. Replaces the legacy
                  inline vehicleDescriptionSection() (kept defined above). */}
              <VehicleDescriptionSection data={selectedCar} />
              {renderUserSection()}
              {renderBonzahSection()}
              {(bonzahProducts?.length > 0 ||
                (selectedCar?.extras ?? []).length > 0) &&
                renderExtrasSection()}
            </div>

            <div className="block flex-grow mt-0 lg:mt-0">
              <div className="block sticky top-28 space-y-4">
                {renderSidebar()}
              </div>
            </div>
          </main>
        </div>
      </>{" "}
    </DetailPagetLayout>
  );
}
